import {
  collection,
  getCountFromServer,
  query,
  where,
} from 'firebase/firestore';
import { useEffect, useState } from 'react';
import { useFirestore, useFirestoreCollectionData } from 'reactfire';

import { Container } from '@mui/material';

import UsersCountRequestsTable from './UsersCountRequestsTable';
import BackupButton from './BackupButton';
import TotalRequestsTable from './TotalRequestsTable';

import {
  BackupTablesWrapper,
  RightSideWrapper,
} from '../../styled/Backup.styled';

const Backup = () => {
  const firestore = useFirestore();
  const changeRequestsCollection = collection(firestore, 'changeRequests');

  const [countRequests, setCountRequests] = useState<Record<string, number>>(
    {},
  );
  const [totalRequests, setTotalRequests] = useState<number | null>(null);

  const usersCollection = collection(firestore, 'users');

  const { data: users } = useFirestoreCollectionData(usersCollection);

  useEffect(() => {
    if (!users) return;

    const fetchCount = async () => {
      const entries = await Promise.all(
        users.map(async (user) => {
          const q = query(
            changeRequestsCollection,
            where('userId', '==', user.uid),
          );

          const snapshot = await getCountFromServer(q);

          return [user.email, snapshot.data().count] as const;
        }),
      );

      const snapshot = await getCountFromServer(changeRequestsCollection);
      setTotalRequests(snapshot.data().count);
      setCountRequests(Object.fromEntries(entries));
    };

    fetchCount();
  }, [users]);

  return (
    <Container>
      <BackupTablesWrapper>
        <UsersCountRequestsTable users={users} countRequests={countRequests} />
        <RightSideWrapper>
          <TotalRequestsTable totalRequests={totalRequests} />
          <BackupButton />
        </RightSideWrapper>
      </BackupTablesWrapper>
    </Container>
  );
};

export default Backup;
